const strize = require('../strize')

module.exports = {
  title: 'ECF',
  imgs: {
    root: 'imagesECF'
  },
  home: '/simuplayers',
  features: {
    elearning: false,
    simu: true,
    eval: true
  },
  bucket: {
    player: {
      bucket: strize(''),
      region: strize(''),
      key: strize(''),
      secret: strize('')
    },
    editor: {
      bucket: strize(''),
      region: strize(''),
      key: strize(''),
      secret: strize('')
    }
  },
  colors: {
    main: '#c73c41',
    bgSideBar: '#232733',
    ActionMail: '#dadada'
  },
  layouts: {
    sidebar: {
      imgLogo: 'Logo.png'
    },
    agencyCreate: {
      logo: false
    }
  }
}
